export default __webpack_public_path__ + "static/media/arrowBasic.7ac6d15a.svg";